import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { memo } from 'react';
import strings from '../../Globalization';
import { CycleReviewForm } from '../../AppGrid/CycleReviewTable';
import { useAdvantageCycleInfo } from './Context';

const CycleReviewFormDialog = () => {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const { cycleReviewFormDialogOpen, onCloseCycleReviewFormDialog, cycleId, approvalStatusId, combos } =
		useAdvantageCycleInfo();
	const handleOnSetActiveRecord = (record, opts = { refresh: true }) => {
		if (typeof onCloseCycleReviewFormDialog === 'function') {
			onCloseCycleReviewFormDialog();
		}
		
	};

	const handleOnRecordSaved = (...args) => {
		onCloseCycleReviewFormDialog(true);
	};

	return (
		<Dialog
			open={cycleReviewFormDialogOpen}
			onClose={onCloseCycleReviewFormDialog}
			sx={{ '& .MuiDialog-paper': { minWidth: '60vw' } }}
			fullScreen={fullScreen}
		>
			<DialogTitle>
				<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
					{strings.ConfirmForApproveCycle}
				</Typography>
			</DialogTitle>
			<DialogContent>
				<CycleReviewForm
					activeRecord={{ record: { selected: cycleId, statusId: approvalStatusId }, combos }}
					setActiveRecord={handleOnSetActiveRecord}
					containerProps={{ elevation: 0 }}
					onRecordSaved={handleOnRecordSaved}
					disableAlerts
				/>
			</DialogContent>
		</Dialog>
	);
};

export default memo(CycleReviewFormDialog);
